import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { CssSelectors } from '../../../styles/styles';

const { colors } = THEME;

export const styleSheet = StyleSheet.create({
	ageRange: {
		fontSize: 14,
		color: colors.text.main,
	},
	container: {
		width: '100%',
		...CssSelectors.allChildren({
			borderRadius: 6,
		}),
	},
	twoColumn: {
		display: 'flex',
		gap: 8,
		marginBottom: 12,
	},
	fullWidth: {
		maxWidth: '100%',
		width: '100%',
	},
	subtitle: {
		marginTop: 16,
		marginBottom: 8,
		color: colors.text.main,
		'::after': {
			color: colors.danger.main,
			content: '"*"',
			display: 'inline',
			marginLeft: '0.25rem',
		},
	},
	formErrorLine: {
		color: colors.danger.dark,
		fontSize: '0.75rem',
		marginTop: 0,
	},
});
